import { render } from "./Cursos.vue?vue&type=template&id=5a0e7666"
import script from "./Cursos.vue?vue&type=script&lang=js"
export * from "./Cursos.vue?vue&type=script&lang=js"

import "./Cursos.vue?vue&type=style&index=0&id=5a0e7666&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__